import { ButtonHTMLAttributes, ReactNode } from 'react';

interface FilterPillProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'value'> {
  label: string;
  value?: ReactNode;
  /** Render in dashed "+ Add filter" style. */
  dashed?: boolean;
  active?: boolean;
}

export function FilterPill({ label, value, dashed, active, className = '', ...rest }: FilterPillProps) {
  return (
    <button
      type="button"
      className={`flex items-center gap-1.5 px-2.5 py-[5px] rounded-md text-[12px] font-medium cursor-pointer bg-panel border ${
        dashed ? 'border-dashed border-border-strong text-text-3' : 'border-border-strong text-text-2 hover:border-text-3'
      } ${active ? 'border-accent text-accent' : ''} ${className}`}
      {...rest}
    >
      <span className={`font-normal ${dashed ? 'text-text-3' : 'text-text-3'}`}>{label}</span>
      {value != null && (
        <span className="text-text font-semibold font-mono text-[11.5px]">{value}</span>
      )}
      {!dashed && <span className="text-text-3">▾</span>}
    </button>
  );
}
